import { Component, OnInit, OnDestroy } from "@angular/core";

import {
  MissionService,
  ThingsSyncService,
  AuthenticationService,
  HTTPCallsService
} from "src/app/_services";
import { ThingUiObject } from "src/app/_models/thingUiObject";
import { AdminUser } from "src/app/_models/adminuser";
import { Subscription } from "rxjs";
import { Thing } from "src/app/_models/thing";
import { DataStore } from "src/app/_services";
import { Router, ActivatedRoute } from "@angular/router";
import { NgxIndexedDBService } from 'ngx-indexed-db';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA
} from "@angular/material/dialog";
import { MsaterControlComponent } from "src/app/dashboard/things/msater-control/msater-control.component"
export interface DialogData {
  status: string;
}

@Component({
  selector: "app-things",
  templateUrl: "./things.component.html",
  styleUrls: ["./things.component.css"]
})
export class ThingsComponent implements OnInit {

  public loading: boolean;
  isSendingStatus: boolean;
  selectedThingId: string = "";
  selectedThingMacId: string = "";
  displayModel = "none";
  oldStatus: Array<string>;
  isHttpcontrol: boolean;
  currentUser: AdminUser;
  subscription: Subscription;
  bodyPayLoad: object;
  isloading: boolean;
  name = new Set()
  masterStatus: string
  existingRppmName = ['bathroom', 'bed room', 'bedroom', 'cellar', 'dinning room', 'dressing', 'entertainment', 'entrance', 'garage', 'garden', 'guesr bedroom', 'hall way', 'home', 'kids bedroom', 'kitchen', 'living room', 'master bedroom', 'office', 'prayer room', 'stairs', 'study room']
  existingPlaceType = ['Restaurent', 'Office']

  thingUIMap: any;
  thingUIObject: Map<string, ThingUiObject> = new Map<string, ThingUiObject>();
  globalThingAndThingUIObject: Map<string, any> = new Map<string, any>();
  selectedThing: ThingUiObject;
  selectedRawThing: Thing;
  data: any;
  selectedPlaceName: string;
  cardName: string

  constructor(

    private missionService: MissionService,
    private dataStore: DataStore,
    private router: Router,
    private route: ActivatedRoute,
    private thingSyncService: ThingsSyncService,
    private authService: AuthenticationService,
    private httpService: HTTPCallsService,
    private dbService: NgxIndexedDBService,
    public dialog: MatDialog
  ) { }

  ngOnInit() {

    this.loading = true;
    this.currentUser = this.authService.currentUserValue;
    this.selectedPlaceName = this.route.snapshot.paramMap.get("label");
    this.thingAndThingUIObjectCall();
    this.missionService.missionAnnounced$.subscribe(mission => {
      switch (mission.split("!#!")[0]) {
        case "DataSaved":
          this.getData();
          break;
        case "ThingsUpdated":
          this.thingAndThingUIObjectCall();
          break;
        case "sort":
          this.selectedPlaceName = mission.split("!#!")[1];
          this.thingAndThingUIObjectCall();
          break;
        case "removeSort":
          this.selectedPlaceName = "";
          this.thingAndThingUIObjectCall();
          break;
      }
    });
  }

  getData() {
    this.dataStore.getAllThingData();
  }


  thingAndThingUIObjectCall() {
    this.name.clear()
    let ThingAndThingUIObject = new Map<string, any>();
    this.dbService.getAll('Things').then(allData => {
      // console.log(allData)
      var thingDataMap = allData

      this.dbService.getAll('thingUiObject').then(allUidata => {
        // console.log(allUidata)
        thingDataMap.forEach(value => {

          if (value['thing'].macId.includes("-")) {

            var macIdcheck = value['thing'].macId.toLowerCase().split("-")[1];
          } else {
            var macIdcheck = value['thing'].macId.toLowerCase().split("/")[2];
          }

          if (this.selectedPlaceName) {
            if (
              this.selectedPlaceName.toLowerCase() === "others" ||
              "others".match(this.selectedPlaceName)
            ) {
              var thingCardName = "-";
              var MatchedStatus = new Map<string, ThingUiObject>();

              allUidata.forEach(data => {


                if (thingCardName == data['thing'].eachthingName || data['thing'].eachthingName == "Others") {
                  MatchedStatus.set(data['uiMacId'], data['thing']);
                }
              })
              if (value['Thing']) {
                if (
                  ((value['Thing'].thingsLocation.placeName === null ||
                    value['Thing'].thingsLocation.placeName === "") &&
                    value['Thing'].roomName === null) ||
                  value['Thing'].roomName === ""
                ) {
                  ThingAndThingUIObject.set("Others", MatchedStatus);
                }
              }
              {
                ThingAndThingUIObject.set("Others", MatchedStatus);
              }

            } else if (
              value['thing'].thingsLocation.placeName
                .toLowerCase()
                .match(this.selectedPlaceName) ||
              this.selectedPlaceName.toLowerCase() ===
              value['thing'].thingsLocation.placeName.toLowerCase() ||
              macIdcheck.match(this.selectedPlaceName)
            ) {
              if (value['thing'].roomName != '') {

                this.cardName =
                  value['thing'].thingsLocation.placeName + "-" + value['thing'].roomName + "*"
                if (this.existingRppmName.includes(value['thing'].roomName)) {
                  this.cardName =
                    this.cardName + 'icon' + value['thing'].roomName;
                }
                else if (this.existingPlaceType.includes(value['thing'].thingsLocation.placeType)) {
                  this.cardName =
                    this.cardName + 'icon' + value['thing'].thingsLocation.placeType
                }
                else {
                  this.cardName =
                    this.cardName + 'icon' + 'pin'
                }

              }
              else if (value['thing'].thingsLocation.placeName) {
                this.cardName = value['thing'].thingsLocation.placeName + '-*iconpin'
              }
              else {
                this.cardName =
                  '-*iconpin'

              }


              var MatchedStatus = new Map<string, ThingUiObject>();
              allUidata.forEach(data => {

                if (this.cardName.split('*')[0].replace('*', '') == data['thing'].eachthingName) {
                  MatchedStatus.set(data['uiMacId'], data['thing']);
                }
              })



              if (MatchedStatus.size > 0) {
                ThingAndThingUIObject.set(this.cardName, MatchedStatus);
              }

            }
          } else {

            this.cardName = ''

            if (value['thing'].roomName != '') {

              this.cardName =
                value['thing'].thingsLocation.placeName + "-" + value['thing'].roomName + "*"
              if (this.existingRppmName.includes(value['thing'].roomName)) {
                this.cardName =
                  this.cardName + 'icon' + value['thing'].roomName;
              }
              else if (this.existingPlaceType.includes(value['thing'].thingsLocation.placeType)) {
                this.cardName =
                  this.cardName + 'icon' + value['thing'].thingsLocation.placeType
              }
              else {
                this.cardName =
                  this.cardName + 'icon' + 'pin'
              }

            }
            else if (value['thing'].thingsLocation.placeName) {
              this.cardName = value['thing'].thingsLocation.placeName + '-*iconpin'
            }
            else {
              this.cardName =
                '-*iconpin'

            }


            var MatchedStatus = new Map<string, ThingUiObject>();
            allUidata.forEach(data => {
              if (data['uiMacId'].includes("thing/esp-EC:FA:BC:62:50:7D")) {
              }


              if (this.cardName.split('*')[0].replace('*', '') == (data['thing'].eachthingName)) {
                MatchedStatus.set(data['uiMacId'], data['thing']);

              }
            })

            if (MatchedStatus.size > 0) {
              if (this.cardName === '-*iconpin') {
                ThingAndThingUIObject.set("Others", MatchedStatus);
                this.dbService.update('locationList', { name: 'Others', id: "Others" }).then(() => {

                })
              }
              else {
                ThingAndThingUIObject.set(this.cardName, MatchedStatus);
                this.dbService.update('locationList', { name: this.cardName.split('-')[0], id: this.cardName.split('-')[0] }).then(() => {

                })

              }
            }

          }

          this.loading = false

        })
        this.globalThingAndThingUIObject = ThingAndThingUIObject;

        this.missionService.announceMission('LocationListFramed')
      })
    })

  }
  thingControl(key: string, macId: string) {
    if (macId.includes("laptop")) {
      this.router.navigate([
        "/dashboard/thingDetails/",
        macId.split("/")[1] + "/" + macId.split("/")[2],
        key.split("/")[3]
      ]);
    } else {
      this.router.navigate([
        "/dashboard/thingDetails/",
        macId.split("/")[1],
        key.split("/")[2]
      ]);
    }
  }

  actionCall(accessory) {
    var payLoad;
    var currentStatuskey = accessory.currentStatus.toLowerCase();
    var currentStatusValue = accessory.currentStatus.toUpperCase();
    if (accessory.accessoryId.includes("curtain")) {
      var currentStatus = accessory.currentStatus.toLowerCase();

      if (currentStatus === "close") {
        payLoad = {
          open: "OPEN"
        };
      } else {
        payLoad = {
          close: "CLOSE"
        };
      }
    } else {
      if (accessory.buildNumber < 6 || accessory.buildNumber == undefined) {
        var status = accessory.currentStatus;
        if (status.toLowerCase() === "on") {
          payLoad = {
            power: {
              power: ["OFF"]
            }
          };
        } else if (status.toLowerCase() === "off") {
          payLoad = {
            power: {
              power: ["ON"]
            }
          };
        }
      } else if (accessory.buildNumber >= 6) {
        var status = accessory.currentStatus;
        if (status.toLowerCase() === "on") {
          payLoad = {
            power: "OFF"
          };
        } else if (status.toLowerCase() === "off") {
          payLoad = {
            power: "ON"
          };
        }
      }
    }
    var topic = accessory.accessoryId + "/" + accessory.controlTopic;
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));

    var phoneNumber = currentUser["phoneNumber"];

    this.httpService
      .mqttPublish(topic, payLoad, phoneNumber)
      .subscribe(data => console.log(data));
  }
  openDialog(eachthing): void {
    const dialogRef = this.dialog.open(MsaterControlComponent, {
      width: "350px",
      data: { name: this.masterStatus }
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result != null || undefined) {

        this.masterOnOffThings(result, eachthing)
      }
    });
  }
  masterOnOffThings(masterStatus, eachThing) {
    var masterOnOffThingsMapNew = new Map<object, object>();
    var masterOnOffThingsMapOld = new Map<object, object>();
    var masterOnOffThingsSetNew = new Set<string>();
    var masterOnOffThingsSetOld = new Set<string>();
    var currentUserData = JSON.parse(localStorage.getItem("currentUser"));
    var phoneNumber = currentUserData["phoneNumber"];
    var payLoad, topic;

    for (let [key, value] of eachThing.value) {
      if (value.buildNumber > 2) {
        masterOnOffThingsMapNew.set(
          value.macId,
          masterStatus
        );
      } else {
        masterOnOffThingsMapOld.set(
          value.accessoryId,
          masterStatus
        );
      }
    }
    // console.log(masterOnOffThingsMapOld);
    // console.log(masterOnOffThingsMapNew);
    if (masterOnOffThingsSetNew) {
      for (let [key, value] of masterOnOffThingsMapNew) {
        var checkStatus = JSON.stringify(value)

        if (checkStatus === '"OFF"') {



          payLoad = { power: "OFF" };
        } else if (checkStatus === '"ON"') {
          payLoad = { power: "ON" };
        }
        topic = key + "/masterControl";
        this.httpService
          .mqttPublish(topic, payLoad, phoneNumber)
          .subscribe(data => {
            console.log(data);
          });
      }
    }
    if (masterOnOffThingsSetOld) {
      for (let [key, value] of masterOnOffThingsMapOld) {
        var checkStatus = JSON.stringify(value)
        if (checkStatus === '"OFF"') {
          payLoad = { power: { power: ["OFF"] } };
        } else if (checkStatus === '"ON"') {
          payLoad = { power: { power: ["ON"] } };
        }
        topic = key + "/powerControl";
        console.log("topic", topic)
        this.httpService
          .mqttPublish(topic, payLoad, phoneNumber)
          .subscribe(data => {
            console.log(data);
          });
      }
    }
  }
}
